module.exports = __webpack_public_path__ + "img/popup-game-sucai.48ab6e75.png";